<script setup lang="ts">
import useToast from '../composables/useToast';

const { isOpen, type, title, message, close } = useToast();
</script>

<template>
  <v-snackbar v-model="isOpen" multi-line :color="type" timeout="5000">
    <v-alert :color="type" :icon="`$${type}`" :title="title" :text="message" class="pa-0"></v-alert>
    <template v-slot:actions>
      <v-btn variant="text" icon="mdi-close" @click="close"></v-btn>
    </template>
  </v-snackbar>
</template>
